module.exports = __webpack_public_path__ + "static/media/hour-glass.aaec57cb.svg";